import { render, staticRenderFns } from "./AppVirtual.vue?vue&type=template&id=c9ec9a76&scoped=true&"
import script from "./AppVirtual.vue?vue&type=script&lang=js&"
export * from "./AppVirtual.vue?vue&type=script&lang=js&"
import style0 from "./AppVirtual.vue?vue&type=style&index=0&id=c9ec9a76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ec9a76",
  null
  
)

export default component.exports